export enum EdsSpecificFieldTypes {
  Status = 'Status',
  StatusWithReason = 'StatusWithReason',
  ClaimSetNumber = 'ClaimSetNumber',
  ClaimSetInsured = 'ClaimSetInsured',
  ClaimSetReporter = 'ClaimSetReporter',
  PolicyNumber = 'PolicyNumber',
  DocumentTypeIcon = 'DocumentTypeIcon',
  DocumentType = 'DocumentType',
  DocumentDate = 'DocumentDate',
  Assignee = 'Assignee',
  LinkedClaims = 'LinkedClaims',
  ProgressBar = 'ProgressBar',
  Link = 'Link',
  BeneficiaryRepresentativeName = 'BeneficiaryRepresentativeName',
  Avatar = 'Avatar',
  NotificationTypesSwitch = 'NotificationTypesSwitch',
  UpdatablePassword = 'UpdatablePassword',
  Milestone = 'Milestone',
  Badge = 'Badge',
  AccountStatus = 'AccountStatus',
  SecurityRole = 'SecurityRole',
  SSN = 'SSN',
  SelectWithTagView = 'SelectWithTagView',
  UserTransition = 'UserTransition',
  Priority = 'Priority',
  ClaimantAccountStatus = 'ClaimantAccountStatus',
  AssignmentQueue = 'AssignmentQueue',
  HelperTag = 'HelperTag',
  PreferredLabel = 'PreferredLabel',
  DataTable = 'DataTable',
  Passcode = 'Passcode',
  TaxablePayee = 'TaxablePayee',
}

export enum EdsGeneralFieldTypes {
  Select = 'Select',
  Input = 'Input',
  Date = 'Date',
  DateTime = 'DateTime',
  Year = 'Year',
  ReportingUser = 'ReportingUser',
  SitusState = 'SitusState',
  SelectOtpChannel = 'SelectOtpChannel',
  SelectNotificationChannel = 'SelectNotificationChannel',
  CauseOfIncident = 'CauseOfIncident',
  LastLogin = 'LastLogin',
  SocialSecurityNumber = 'SocialSecurityNumber',
  InsuredPerson = 'InsuredPerson',
}
